module.exports = "/packs/media/images/oldercouple_strolling-840514dad2eb14fa3ed6d6dcac625690.jpg";